<script setup>
import { ref, watch, onMounted } from 'vue'
import { deepClone } from '@/utils/util'
import AnswerWapper from '../../wapper.vue'
import { loadSlot } from '../utils'
import { PROPS_OPTIONS } from '../../common/props-options'

const props = defineProps({
  ...PROPS_OPTIONS,
  type: {
    type: Boolean,
    default: true
  }
})
const emit = defineEmits(['on-change'])

const slotComponents = ref({
  'title-icon': null,
  'title-index': null,
  'answer-row': null,
  'footer-box': null
})

const inputAuth = ref([])
const inputArr = ref([])
const copyItem = ref({})

function initItem(newVal) {
  copyItem.value = deepClone(newVal)
  inputArr.value = copyItem.value.title.match(/<filter><\/filter>/g) || []
  copyItem.value.answerArr = []
  if (copyItem.value.submitAnswer) {
    copyItem.value.answerArr = copyItem.value.submitAnswer.split(',') || []
  }
}

function onInput(e, index) {
  copyItem.value.answerArr.splice(index, 1, e)
}

function replaceTitle() {
  let text = ''
  const titleArr = copyItem.value.title
    .replace(/[\r\n]/g, '<br/>')
    .split('<filter></filter>')
  const newTitleArr = []
  const blanksCount = (copyItem.value.title.match(/<filter><\/filter>/g) || [])
    .length
  // 可答题 数据需要回填
  const newAnswerArr = titleArr?.map((item, index) => {
    return `<span style="border-bottom:1px solid #1e1e1e;color:#1e1e1e;font-weight:400;padding: 1px 5px;"><span style="display:inline-block;width:20px;height:20px;line-height:20px;border:1px solid #1E1E1E;border-radius: 50%;text-align:center;">${
      index + 1
    }</span></span>`
  })
  titleArr.map((item, index) => {
    newTitleArr.push(item)
    // 只插入总filter个数的dom节点
    if (blanksCount < index + 1) return
    if (copyItem.value.answerArr) {
      // 有答案
      newTitleArr.push(newAnswerArr[index])
    } else {
      // 没答案
      if (props.item.title.indexOf('<filter></filter>') < 0) return
      newTitleArr.push(
        `<span style="border-bottom:1px solid #1e1e1e;color:#1e1e1e;font-weight:400;padding:1px 5px;"><span style="display:inline-block;width:20px;height:20px;line-height:20px;border:1px solid #1E1E1E;border-radius: 50%;text-align:center;">${
          index + 1
        }</span></span>`
      )
    }
  })
  text = newTitleArr.join('')
  return text
}

function handleClick(index, copyItem) {
  const dom = inputAuth.value[index].$el
  const inputDom = dom.querySelector('input')
  if (props.beforeChange(copyItem.answerArr[index], copyItem)) {
    inputDom.focus()
    emit('on-change', copyItem)
  } else {
    inputDom.blur()
  }
}

function onSubmit() {
  return new Promise((resolve, reject) => {
    validate({
      success: () => {
        copyItem.value.submitAnswer = copyItem.value.answerArr.join(',')
        copyItem.value.submitAnswerObj = {
          intVal: copyItem.value.examId,
          stringVal: copyItem.value.submitAnswer
        }
        resolve(copyItem.value)
      },
      fail: error => {
        reject(error)
      }
    })
  })
}

function validate({ success, fail }) {
  const arr = copyItem.value.answerArr.filter(item => item)
  if (arr.length === inputArr.value.length) {
    success()
  } else {
    fail({
      row: copyItem.value,
      message: '请填写答案'
    })
  }
}

function reset() {
  initItem(props.item)
}

watch(
  () => props.item,
  newVal => {
    initItem(newVal)
  },
  {
    immediate: true,
    deep: true
  }
)

onMounted(async() => {
  const blankFillSlots = await loadSlot(
    'blank_fill',
    Object.keys(slotComponents.value),
    props.themeName
  )
  slotComponents.value = {
    ...blankFillSlots
  }
})
defineExpose({
  onSubmit,
  reset
})
</script>

<template>
  <AnswerWapper
    :disabled="disabled"
    :is-show-correct="isShowCorrect"
    :copy-item="copyItem"
    :class="[themeName, 'blank_fill']"
  >
    <template #exam-title>
      <component :is="slotComponents['title-icon']" />
      <component
        :is="slotComponents['title-index']"
        :title-index="copyItem.titleIndex"
        :exam-index="copyItem.examIndex"
      />
      <span v-safe-html="replaceTitle(item.title)" class="flex-box" />
    </template>
    <template #exam-answer-box>
      <template v-for="(inputArrItem, index) in inputArr">
        <div :key="index" class="question-input-box">
          <div class="placeholder-box">
            <span class="required-span">*</span>
          </div>
          <div style="flex-shrink: 0;">{{ index + 1 }}.</div>
          <van-field
            v-if="copyItem.valueType === 1"
            ref="inputAuth"
            :value="copyItem.answerArr[index]"
            class="input"
            :disabled="disabled || !type"
            type="number"
            placeholder="请输入答案"
            @input="onInput($event, index)"
            @click.native="handleClick(index, copyItem)"
          />
          <qxs-input
            v-else
            ref="inputAuth"
            v-model.trim="copyItem.answerArr[index]"
            :disabled="disabled || !type"
            class="mgn-l10"
            :placeholder="`请输入答案`"
            size="small"
            @click.native="handleClick(index, copyItem)"
          />
        </div>
      </template>
    </template>
    <template #answer-result-box>
      <div v-if="disabled && isShowCorrect" class="answer-result-box">
        <div class="answer-result">
          <div class="answer-sorce">
            <!-- 正确答案 -->
            <template v-for="(it, ind) of copyItem.examAnswerResults || []">
              <span :key="ind">
                填空{{ ind + 1 }}参考答案为: {{ it.correctAnswer }}
              </span>
            </template>
            <template
              v-if="
                !(
                  copyItem.examAnswerResults &&
                  copyItem.examAnswerResults.length
                )
              "
            >
              <span style="color: #30c691;">本题暂无参考答案</span>
            </template>
          </div>
          <div v-if="copyItem.analysis" style="color: #6e6d6b;">
            答题解析：<span>{{ copyItem.analysis }}</span>
          </div>
        </div>
      </div>
    </template>
    <template v-if="disabled" #footer-box>
      <component :is="slotComponents['footer-box']" />
    </template>
  </AnswerWapper>
</template>

<style lang="scss" scoped>
.blank_fill {
  margin-bottom: 15px;
}
.question-input-box {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 45px;
  .input {
    background-color: transparent;
  }
  :deep(.qxs-input-wrapper) {
    border: 0;
    border-bottom: 1px solid #f0f0f0;
  }
}
.input {
  border-bottom: 1px solid #f0f0f0;
}
.placeholder-box {
  width: 10px;
  height: inherit;
  line-height: 45px;
}
.required-span {
  color: #ff8383;
}
.mgn-l10 {
  margin-left: 10px;
}
// 答案解析
.answer-result-box {
  margin-top: 1px;
  padding: 0 10px;
  font-size: 12px;
}
.answer-result {
  color: $text-color-main;
  background: #fffbe4;
  padding: 15px;
}
.answer-sorce {
  color: $color-danger;
}
.department-drawer-box :deep(.qxs-drawer-body) {
  padding: 0;
}
</style>
